'use strict'

import Api from '@/api/interview.js'

const state = {
  error: null,
  test: null
}

const actions = {
  fetch ({commit}, {interview}) {
    return Api.fetchOneTest(interview.token)
      .then(data => commit('fetchSuccess', data))
      .catch(err => commit('fetchFailure', err))
  },

  saveAnswer ({commit}, {interview, questionId, model}) {
    return Api.saveTestAnswers(interview.token, questionId, [model])
      .then(data => commit('answerSuccess', {questionId, data}))
      .catch(err => commit('answerFailure', err))
  },

  end ({commit}, {interview}) {
    return Api.endTest(interview.token)
  }
}

const mutations = {
  fetchSuccess (state, data) {
    state.test = data
  },

  fetchFailure (state, err) {
    state.error = err
  },

  answerSuccess (state, {questionId, data}) {
    state.test.questions = state.test.questions
      .map(question => question.id === questionId
           ? {
             ...question,
             answers: question.answers
               .map(answer => answer.id === data.id ? data : answer)
           }
           : question)
  },

  answerFailure (state, err) {
    state.error = err
  }
}

const getters = {
  error (state, getters) {
    return state.error
  },

  one (state, getters) {
    return state.test || {}
  },

  questions (state, getters) {
    return state.test ? state.test.questions : []
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
